var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoRound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4419",
    "data-name": "Rectangle 4419",
    width: 70,
    height: 70,
    transform: "translate(-10884 -23996)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36172",
    "data-name": "Path 36172",
    d: "M33,67.076c-.213-.01-.426-.02-.636-.034a31.112,31.112,0,0,1-21.607-10.82q-.164-.191-.322-.383A32.371,32.371,0,0,1,2.9,35C2.9,17.3,16.987,2.9,34.311,2.9A31.487,31.487,0,0,1,63.644,23.512a31.961,31.961,0,0,1,1.147,3.7A32.894,32.894,0,0,1,64.6,43.54a.552.552,0,0,0-.263-.061l-.324,0a.6.6,0,0,1-.6-.59L63.395,41.3a.6.6,0,0,0-.6-.592h-.006a.594.594,0,0,1-.6-.577l-.134-4.3-.259,0-.018,4.3a.6.6,0,0,1-.59.6l-1.451.014a.592.592,0,0,0-.59.6l.014,1.591a.6.6,0,0,1-.59.6l-1.872.018a2.233,2.233,0,0,0-2.211,2.255l.053,5.1a.6.6,0,0,1-.592.6l-18.248.18a.606.606,0,0,1-.377-.128l-.772-.612a.6.6,0,0,0-.377-.13l-8.956.091a.6.6,0,0,0-.551.809l.608,1.589a47.012,47.012,0,0,1,7.6.513c4.1.6,9.172,1.329,14.41,1.832,3.528.342,7.132.577,10.558.6-.107.126-.217.249-.328.373a.342.342,0,0,0-.026.03,31.767,31.767,0,0,1-6.879,5.785A30.86,30.86,0,0,1,34.311,67.1q-.66,0-1.311-.026M34.311,0A33.757,33.757,0,0,0,10.038,10.262a35.5,35.5,0,0,0,0,49.475A33.756,33.756,0,0,0,34.311,70c.776,0,1.552-.026,2.322-.081q.516-.037,1.029-.087a33.731,33.731,0,0,0,14.485-4.925,34.545,34.545,0,0,0,7.536-6.346q1.03-1.149,1.945-2.381c.184-.243.365-.494.541-.746A35.383,35.383,0,0,0,68.622,35a36.272,36.272,0,0,0-.255-4.312,35.132,35.132,0,0,0-9.785-20.426A33.745,33.745,0,0,0,34.311,0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.106,
    y1: 0.906,
    x2: 0.108,
    y2: 0.906,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491,
    stopColor: "#89cc50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48b14b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36173",
    "data-name": "Path 36173",
    d: "M18.175,50.289a32.371,32.371,0,0,0,7.539,20.839,65.334,65.334,0,0,1,12.874-2.439A26.642,26.642,0,0,1,78.923,38.8,31.487,31.487,0,0,0,49.591,18.187c-17.324,0-31.416,14.4-31.416,32.1",
    transform: "translate(-18.175 -18.187)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.048,
    y1: 1.267,
    x2: -0.045,
    y2: 1.267,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36174",
    "data-name": "Path 36174",
    d: "M80.344,334.632c-.5.01-.986.024-1.469.053-.168.008-.336.018-.5.03A65.326,65.326,0,0,0,65.5,337.155q.158.192.322.383a31.112,31.112,0,0,0,21.607,10.82c.211.014.424.024.636.034q.65.027,1.311.026a30.86,30.86,0,0,0,16.306-4.656,31.769,31.769,0,0,0,6.879-5.785.346.346,0,0,1,.026-.031c.111-.124.221-.247.328-.373-3.426-.02-7.031-.255-10.558-.6-5.238-.5-10.311-1.236-14.41-1.832a47.739,47.739,0,0,0-6.869-.519q-.369,0-.733.006",
    transform: "translate(-65.498 -334.626)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -1.936,
    y1: 0.706,
    x2: -1.924,
    y2: 0.706,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36175",
    "data-name": "Path 36175",
    d: "M81.534,155.369v2.765h6.932l-7.192,8.531v2.886H92.49v-2.886H85.2l7.049-8.531v-2.765Z",
    transform: "translate(-81.274 -155.369)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -1.047,
    y1: 3.08,
    x2: -1.034,
    y2: 3.08,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89cc50"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36176",
    "data-name": "Path 36176",
    d: "M164.034,185.08a1.822,1.822,0,0,1,.421-.58,2.118,2.118,0,0,1,.651-.411,2.239,2.239,0,0,1,.881-.162,1.791,1.791,0,0,1,1.342.542,1.741,1.741,0,0,1,.5,1.3h-3.965a1.839,1.839,0,0,1,.17-.689m.119-2.954a5.054,5.054,0,0,0-1.721,1.032,4.806,4.806,0,0,0-1.153,1.612,5.466,5.466,0,0,0,0,4.207,4.84,4.84,0,0,0,1.153,1.612,5.079,5.079,0,0,0,1.721,1.03,6.116,6.116,0,0,0,2.114.361,5.458,5.458,0,0,0,2.284-.5,4.777,4.777,0,0,0,1.821-1.423l-2.1-1.54a3.375,3.375,0,0,1-.893.851,2.273,2.273,0,0,1-1.251.33,2.209,2.209,0,0,1-1.482-.511,2.369,2.369,0,0,1-.781-1.372h6.97v-.944a6.443,6.443,0,0,0-.323-2.1,4.623,4.623,0,0,0-.91-1.612,3.935,3.935,0,0,0-1.442-1.032,4.782,4.782,0,0,0-1.893-.362,6.121,6.121,0,0,0-2.114.362",
    transform: "translate(-160.858 -181.764)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -2.406,
    y1: 3.839,
    x2: -2.391,
    y2: 3.839,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36177",
    "data-name": "Path 36177",
    d: "M239.109,182.215a3.681,3.681,0,0,0-1.142,1.353h-.041V182h-3v9.737h3v-4.067a9.507,9.507,0,0,1,.083-1.321,2.485,2.485,0,0,1,.349-1.03,1.8,1.8,0,0,1,.77-.672,3.168,3.168,0,0,1,1.365-.241,4.008,4.008,0,0,1,.649.051,4.493,4.493,0,0,1,.632.151v-2.746a2.655,2.655,0,0,0-.481-.079c-.174-.013-.347-.021-.521-.021a2.9,2.9,0,0,0-1.663.451",
    transform: "translate(-234.923 -181.764)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -5.02,
    y1: 3.985,
    x2: -4.998,
    y2: 3.985,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36178",
    "data-name": "Path 36178",
    d: "M285.2,188.656a2.838,2.838,0,0,1,0-3.567,2.648,2.648,0,0,1,3.546,0,2.846,2.846,0,0,1,0,3.567,2.654,2.654,0,0,1-3.546,0m-.342-6.53a5.077,5.077,0,0,0-1.723,1.032,4.828,4.828,0,0,0-1.151,1.612,5.464,5.464,0,0,0,0,4.207,4.863,4.863,0,0,0,1.151,1.612,5.1,5.1,0,0,0,1.723,1.03,6.372,6.372,0,0,0,4.226,0,5.094,5.094,0,0,0,1.725-1.03,4.832,4.832,0,0,0,1.149-1.612,5.443,5.443,0,0,0,0-4.207,4.8,4.8,0,0,0-1.149-1.612,5.068,5.068,0,0,0-1.725-1.032,6.343,6.343,0,0,0-4.226,0",
    transform: "translate(-281.561 -181.764)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -3.919,
    y1: 3.825,
    x2: -3.905,
    y2: 3.825,
    xlinkHref: "#linear-gradient-4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_31",
    "data-name": "Mask Group 31",
    transform: "translate(10884 23996)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7372",
    "data-name": "Group 7372",
    transform: "translate(-10882.6 -23996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7288",
    "data-name": "Group 7288"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7287",
    "data-name": "Group 7287",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4373",
    "data-name": "Rectangle 4373",
    width: 87.15,
    height: 86.241,
    transform: "translate(-19.758 63.89) rotate(-72.815)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7290",
    "data-name": "Group 7290",
    transform: "translate(2.896 2.897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7289",
    "data-name": "Group 7289",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4374",
    "data-name": "Rectangle 4374",
    width: 60.748,
    height: 52.942,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7292",
    "data-name": "Group 7292",
    transform: "translate(10.435 53.31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7291",
    "data-name": "Group 7291",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4375",
    "data-name": "Rectangle 4375",
    width: 14.018,
    height: 47.482,
    transform: "translate(-0.066 13.792) rotate(-89.727)",
    fill: "url(#linear-gradient-3)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7294",
    "data-name": "Group 7294",
    transform: "translate(12.948 24.752)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7293",
    "data-name": "Group 7293",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4376",
    "data-name": "Rectangle 4376",
    width: 11.996,
    height: 14.79,
    transform: "translate(-0.796 0.045) rotate(-3.225)",
    fill: "url(#linear-gradient-4)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7296",
    "data-name": "Group 7296",
    transform: "translate(25.627 28.957)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7295",
    "data-name": "Group 7295",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4377",
    "data-name": "Rectangle 4377",
    width: 10.535,
    height: 10.761,
    transform: "matrix(0.998, -0.056, 0.056, 0.998, -0.574, 0.032)",
    fill: "url(#linear-gradient-5)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7298",
    "data-name": "Group 7298",
    transform: "translate(37.426 28.957)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7297",
    "data-name": "Group 7297",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4378",
    "data-name": "Rectangle 4378",
    width: 7.401,
    height: 10.346,
    transform: "translate(-0.56 0.032) rotate(-3.225)",
    fill: "url(#linear-gradient-6)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7300",
    "data-name": "Group 7300",
    transform: "translate(44.856 28.957)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7299",
    "data-name": "Group 7299",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4379",
    "data-name": "Rectangle 4379",
    width: 11.376,
    height: 10.808,
    transform: "translate(-0.574 0.032) rotate(-3.225)",
    fill: "url(#linear-gradient-7)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRound);
export default __webpack_public_path__ + "static/media/logo-round.59954d47abbeb59c391baf023e92fdaa.svg";
export { ForwardRef as ReactComponent };